import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AppMuiTheme } from './components/theme';
import { ThemeProvider } from './contexts/ThemeContext';
import './css/main.css';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <AppMuiTheme>
        <Router>
          <App />
        </Router>
      </AppMuiTheme>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
